/* Aprés tip-box lengths: existence filtering only; Warehouse owns inventory and cart behavior. */
(function () {
  'use strict';

  function resolve(variants, selection, lengthIndex) {
    var selected = selection.slice();
    var allowed = [];
    variants.forEach(function (variant) {
      var options = variant.options;
      if (!Array.isArray(options) || options.length !== selected.length) return;
      var matches = selected.every(function (value, index) {
        return index === lengthIndex || options[index] === value;
      });
      if (matches && allowed.indexOf(options[lengthIndex]) === -1) allowed.push(options[lengthIndex]);
    });
    var changed = allowed.length > 0 && allowed.indexOf(selected[lengthIndex]) === -1;
    if (changed) selected[lengthIndex] = allowed[0];
    return { allowed: allowed, selected: selected, changed: changed };
  }

  if (typeof module === 'object' && module.exports) module.exports = { resolve: resolve };
  if (typeof document === 'undefined' || typeof window === 'undefined') return;
  if (window.ddApresLengthFilterLoaded) return;
  window.ddApresLengthFilterLoaded = true;

  var pickerSelector = '[data-dd-apres-picker="8331764433194"]';
  var controlSelector = '.product-form__single-selector[data-option-position]';
  var states = new WeakMap();

  function stateFor(picker) {
    if (states.has(picker)) return states.get(picker);
    var script = picker.querySelector('[data-dd-apres-variants]');
    if (!script) return null;
    var config;
    try { config = JSON.parse(script.textContent); } catch (error) { return null; }
    if (String(config.productId) !== '8331764433194' || config.lengthIndex !== 2 ||
        !Array.isArray(config.variants) || !config.variants.length ||
        !config.variants.every(function (variant) {
          return Array.isArray(variant.options) && variant.options.length === 3 &&
            variant.options.every(function (value) { return typeof value === 'string'; });
        })) return null;
    var state = { config: config, pending: false };
    states.set(picker, state);
    return state;
  }

  function controlsFor(picker, position) {
    return Array.prototype.slice.call(picker.querySelectorAll(
      '.product-form__single-selector[data-option-position="' + position + '"]'
    ));
  }

  function currentControl(controls) {
    return controls.find(function (control) { return control.tagName === 'SELECT' || control.checked; });
  }

  function filter(picker) {
    var state = stateFor(picker);
    if (!state) return null;
    var groups = [1, 2, 3].map(function (position) { return controlsFor(picker, position); });
    var current = groups.map(currentControl);
    if (current.some(function (control) { return !control; })) return null;
    var result = resolve(state.config.variants, current.map(function (control) { return control.value; }), 2);
    if (!result.allowed.length) return null; // Unexpected product schema: keep Warehouse's fallback.

    groups[2].forEach(function (control) {
      if (control.tagName === 'SELECT') {
        Array.prototype.forEach.call(control.options, function (option) {
          var exists = result.allowed.indexOf(option.value) !== -1;
          option.hidden = !exists;
          // Disabled also excludes hidden options from native mobile pickers.
          option.disabled = !exists;
        });
        control.value = result.selected[2];
      } else {
        var exists = result.allowed.indexOf(control.value) !== -1;
        var swatch = control.closest('.block-swatch, .color-swatch, .variant-swatch');
        if (swatch) swatch.hidden = !exists;
        control.disabled = !exists;
        control.checked = control.value === result.selected[2];
      }
    });
    var lengthControl = currentControl(groups[2]);
    var row = lengthControl && lengthControl.closest('.product-form__option');
    var label = row && row.querySelector('.product-form__selected-value');
    if (label && label.textContent !== result.selected[2]) label.textContent = result.selected[2];
    return { state: state, changed: result.changed, control: lengthControl };
  }

  function sync(picker) {
    var result = filter(picker);
    if (!result || !result.changed || result.state.pending) return;
    result.state.pending = true;
    // Warehouse caches the changed option only. Notify it after the original
    // event has completed its id/price/image update, coalescing rapid changes.
    Promise.resolve().then(function () {
      result.state.pending = false;
      if (!picker.isConnected) return;
      var latest = filter(picker);
      if (latest && latest.control) latest.control.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function scan(root) {
    if (root.matches && root.matches(pickerSelector)) sync(root);
    if (root.querySelectorAll) root.querySelectorAll(pickerSelector).forEach(sync);
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target.matches || !target.matches(controlSelector)) return;
    var picker = target.closest(pickerSelector);
    if (picker) sync(picker);
  }, true);

  function start() {
    scan(document);
    // Quick view and Theme Editor replace markup without reloading this asset.
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) { if (node.nodeType === 1) scan(node); });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  // This asset is deferred before theme.js. Wait until all deferred theme
  // scripts have attached their variant listeners before initial recovery.
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
